import { usePdfDownload } from "@/hooks/usePdfDownload";

import { Receipt } from "@/types/receipt";

import { Button } from "@/components/common";

import { translate } from "@/utils/formatters";

import { cleanStoreLocationUrl } from "@/api/locations";

import styles from "./Header.module.css";

interface HeaderProps {
  lang: string;
  onLanguageChange: (lang: string) => void;
  user_id?: string;
  zeipt_receipt_transnr: string;
  receipt: Receipt;
  storeLocationUrl?: string | null;
}

export const Header = ({
  lang,
  onLanguageChange,
  user_id,
  zeipt_receipt_transnr,
  receipt,
  storeLocationUrl,
}: HeaderProps) => {
  const { isLoading, downloadPdf } = usePdfDownload({
    user_id: user_id ?? "",
    zeipt_receipt_transnr,
    receipt,
    lang,
  });

  return (
    <div className={`header ${styles.header}`}>
      {/* View Store button on the left */}
      <div>
        {storeLocationUrl && (
          <Button
            href={cleanStoreLocationUrl(storeLocationUrl)}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.actionButton}
            text={translate(lang, "Vis butikk", "View store")}
          />
        )}
      </div>

      {/* Download PDF and Language selector grouped on the right */}
      <div className={styles.rightSection}>
        {user_id && (
          <Button
            onClick={downloadPdf}
            className={styles.actionButton}
            text={translate(lang, "Last ned PDF", "Download PDF")}
            isLoading={isLoading}
          />
        )}

        <select
          className={`tag ${styles.languageSelect}`}
          id="language"
          defaultValue={lang}
          name="language"
          onChange={(e) => onLanguageChange(e.target.value)}
        >
          <option value="nor">NOR</option>
          <option value="eng">ENG</option>
        </select>
      </div>
    </div>
  );
};
